import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Plus, Edit2 } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const MODIFIER_GROUPS = [{
  name: 'SAUCE OPTIONS',
  appliesTo: 'Burgeri, Giros',
  selection: 'Multiple (max 3)',
  required: false,
  options: [{
    name: 'Ketchup',
    price: '+0 RSD',
    cost: '—',
    active: true
  }, {
    name: 'Mayo',
    price: '+0 RSD',
    cost: '—',
    active: true
  }, {
    name: 'BBQ Sauce',
    price: '+0 RSD',
    cost: '—',
    active: true
  }, {
    name: 'Tartar',
    price: '+50 RSD',
    cost: '15 RSD',
    active: true
  }, {
    name: 'Extra sauce',
    price: '+30 RSD',
    cost: '10 RSD',
    active: true
  }]
}, {
  name: 'REMOVE INGREDIENTS',
  appliesTo: 'Burgeri',
  selection: 'Multiple',
  required: false,
  options: [{
    name: 'No onion',
    price: '+0 RSD',
    usage: '23 orders',
    active: true
  }, {
    name: 'No pickles',
    price: '+0 RSD',
    usage: '8 orders',
    active: true
  }, {
    name: 'No lettuce',
    price: '+0 RSD',
    usage: '5 orders',
    active: true
  }, {
    name: 'No tomato',
    price: '+0 RSD',
    usage: '3 orders',
    active: true
  }]
}, {
  name: 'EXTRAS',
  appliesTo: 'Burgeri',
  selection: 'Multiple',
  required: false,
  options: [{
    name: 'Extra cheese',
    price: '+80 RSD',
    cost: '25 RSD',
    margin: '69%',
    active: true
  }, {
    name: 'Extra bacon',
    price: '+120 RSD',
    cost: '45 RSD',
    margin: '63%',
    active: true
  }, {
    name: 'Extra patty',
    price: '+250 RSD',
    cost: '90 RSD',
    margin: '64%',
    active: true
  }]
}];
export function Modifiers() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1312">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1313">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1314">Modifiers</h1>
        <Button icon={<Plus size={16} data-id="element-1316" />} data-id="element-1315">Add Group</Button>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1317" />

      <div className="space-y-6" data-id="element-1318">
        {MODIFIER_GROUPS.map((group, i) => <Card key={i} noPadding data-id="element-1319">
            <div className="p-4 border-b border-white/5 flex justify-between items-start bg-background-elevated/30" data-id="element-1320">
              <div data-id="element-1321">
                <h3 className="font-bold text-lg" data-id="element-1322">{group.name}</h3>
                <div className="text-sm text-text-secondary mt-1" data-id="element-1323">
                  Applies to:{' '}
                  <span className="text-text-primary" data-id="element-1324">{group.appliesTo}</span>
                </div>
              </div>
              <div className="text-right text-sm text-text-secondary" data-id="element-1325">
                <div data-id="element-1326">
                  Selection:{' '}
                  <span className="text-text-primary" data-id="element-1327">{group.selection}</span>
                </div>
                <div data-id="element-1328">
                  Required:{' '}
                  <span className="text-text-primary" data-id="element-1329">
                    {group.required ? 'Yes' : 'No'}
                  </span>
                </div>
              </div>
            </div>

            <div className="p-4" data-id="element-1330">
              <div className="grid grid-cols-4 text-xs font-bold text-text-secondary uppercase mb-2 px-2" data-id="element-1331">
                <div className="col-span-2" data-id="element-1332">Option</div>
                <div data-id="element-1333">Price</div>
                <div className="text-right" data-id="element-1334">Status</div>
              </div>
              <div className="space-y-1" data-id="element-1335">
                {group.options.map((opt, j) => <div key={j} className="grid grid-cols-4 items-center p-2 hover:bg-white/5 rounded transition-colors" data-id="element-1336">
                    <div className="col-span-2 font-medium" data-id="element-1337">{opt.name}</div>
                    <div className="font-mono text-sm" data-id="element-1338">{opt.price}</div>
                    <div className="text-right" data-id="element-1339">
                      <span className="text-xs font-bold text-accent-success" data-id="element-1340">
                        ● Active
                      </span>
                    </div>
                  </div>)}
              </div>

              <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-white/5" data-id="element-1341">
                <Button size="sm" variant="secondary" data-id="element-1342">
                  Edit Group
                </Button>
                <Button size="sm" icon={<Plus size={14} data-id="element-1344" />} data-id="element-1343">
                  Add Option
                </Button>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}